module.exports = __webpack_public_path__ + "img/Exhibition_Logo.cf902ba6.png";